<mat-accordion multi displayMode="flat" class="run-log-accordion">
  <!-- Individual run panels — last run expanded -->
  @for (run of runs(); track run.runNumber) {
    <mat-expansion-panel
      class="run-log-panel"
      [expanded]="isLastRun(run)"
      (mouseenter)="runHover.emit(run.successCount)"
      (mouseleave)="runHover.emit(null)"
    >
      <mat-expansion-panel-header collapsedHeight="40px" expandedHeight="40px">
        <mat-panel-title class="run-log-panel__title">
          <span class="run-log-panel__run-number">Experiment {{ run.runNumber }}</span>
          <span class="run-log-panel__stats">
            <span class="run-log-panel__stat-group">
              <span class="run-log-panel__stat-latex" [innerHTML]="successKLabelHtml"></span>
              <span class="run-log-panel__stat-latex" [innerHTML]="successValueHtml(run.successCount)"></span>
            </span>
            <span class="run-log-panel__stat-divider"></span>
            <span class="run-log-panel__stat-group">
              <span class="run-log-panel__stat-latex" [innerHTML]="nLabelHtml"></span>
              <span class="run-log-panel__stat-latex" [innerHTML]="trialsValueHtml(run.trials)"></span>
            </span>
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <dojo-experiment-run-detail
          [results]="run.results"
          [experiment]="experiment()"
          [targetOutcomes]="targetOutcomes()"
          [successProbability]="successProbability()"
        />
      </ng-template>
    </mat-expansion-panel>
  }
</mat-accordion>
